/* eslint-disable camelcase, eqeqeq */
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import classNames from 'classnames';

import { updateRoleExtra } from '../../../actions/BookingRequest';
import SelectRoleComponent from '../../operations/shifts/SelectRoleComponent';
import {
    serviceTypes,
    vehicleTypes,
} from '../../../consts';
import { TRootState } from '../../../reducers';
import { TConstruction, TDriver, THospitality, TIndustry, TServiceKey } from '../../../types';


const rolesForDriverWithoutVehicles = [
    vehicleTypes.CLASS_1,
    vehicleTypes.CLASS_2,
    vehicleTypes.TONNE_7_5,
    vehicleTypes.COACH,
];

type TRoleData = {
    construction: TConstruction;
    driver: TDriver;
    hospitality: THospitality;
    industry: TIndustry;
}

type TRoleDetailCard = {
    roleData: TRoleData;
    service_key: TServiceKey;
    mode?: string;
    isForJobEdit?: boolean;
    className?: string;
    displayRoleIcon?: boolean;
};

export default function RoleDetailCard({
    roleData,
    service_key,
    mode,
    isForJobEdit,
    className,
    displayRoleIcon = true,
}: TRoleDetailCard) {
    const dispatch = useDispatch();

    const { servicesStructure, user } = useSelector((state: TRootState) => state);

    const changeExtraDetails = (e: React.FormEvent<HTMLInputElement>) => {
        const { name: field, value } = e.currentTarget;

        if (service_key === serviceTypes.DRIVER) {
            if (field === 'vehicle_type') {
                if (value != '4') {
                    dispatch(updateRoleExtra(service_key, 'minimum_delivery_box', 0));
                } else if (roleData.driver.vehicle_type != '4') {
                    dispatch(updateRoleExtra(service_key, 'minimum_delivery_box', 4));
                    dispatch(updateRoleExtra(service_key, 'own_vehicle', 1));
                }
                if (value != '1') {
                    dispatch(updateRoleExtra(service_key, 'medium_van', 0));
                    dispatch(updateRoleExtra(service_key, 'large_van', 0));
                } else if (+roleData.driver.vehicle_type !== vehicleTypes.VAN) {
                    dispatch(updateRoleExtra(service_key, 'medium_van', 1));
                    dispatch(updateRoleExtra(service_key, 'large_van', 0));
                    dispatch(updateRoleExtra(service_key, 'own_vehicle', 1));
                }

                if (rolesForDriverWithoutVehicles.includes(+value)) {
                    dispatch(updateRoleExtra(service_key, 'own_vehicle', 0));
                }

                if (value != '5' && value != '6') {
                    dispatch(updateRoleExtra(service_key, 'adr', 0));
                    dispatch(updateRoleExtra(service_key, 'hiab', 0));
                }
            } else if (field === 'van_size') {
                if (value === 'S') {
                    dispatch(updateRoleExtra(service_key, 'medium_van', 0));
                    dispatch(updateRoleExtra(service_key, 'large_van', 0));
                } else if (value === 'M') {
                    dispatch(updateRoleExtra(service_key, 'medium_van', 1));
                    dispatch(updateRoleExtra(service_key, 'large_van', 0));
                } else {
                    dispatch(updateRoleExtra(service_key, 'medium_van', 0));
                    dispatch(updateRoleExtra(service_key, 'large_van', 1));
                }
            } else if (field === 'minimum_delivery_box') {
                if (value == '0') {
                    dispatch(updateRoleExtra(service_key, 'own_vehicle', 0));
                } else {
                    dispatch(updateRoleExtra(service_key, 'own_vehicle', 1));
                }
            } else if (field === 'adr') {
                if (roleData.driver.adr == 1) {
                    dispatch(updateRoleExtra(service_key, field, 0));
                    return;
                }
            } else if (field === 'hiab') {
                if (roleData.driver.hiab == 1) {
                    dispatch(updateRoleExtra(service_key, field, 0));
                    return;
                }
            }
            dispatch(updateRoleExtra(service_key, field, value));

        } else {
            // handle role change
            const keysToSkip = ['label', 'icon_name', 'role_field_name', 'role_filter_name'];
            const structure = servicesStructure[service_key];
            const fieldName = structure.role_field_name;
            const filterName = structure.role_filter_name;
            const roles = structure[filterName];

            if (value in roles) {
                Object.entries(roles)
                    .filter(([roleName]) => !['', value].includes(roleName))
                    .forEach(([, roleStructure]) => {
                        Object.entries(roleStructure)
                            .filter(([skill]) => !keysToSkip.includes(skill) && !(skill in roles[value]))
                            .forEach(([skill]) => {
                                dispatch(updateRoleExtra(service_key, skill, 0));
                            });
                    });
                dispatch(updateRoleExtra(service_key, field, value));

            // @ts-ignore-next-line
            } else if (roleData[service_key][fieldName] && (field in roles[roleData[service_key][fieldName]])) {
                // handle skill change
                // @ts-ignore-next-line
                dispatch(updateRoleExtra(service_key, field, +roleData[service_key][field] ? 0 : 1));
            }
        }
    };

    const roleItemClassName = `role-item${isForJobEdit ? ' disabled' : ''}`;

    const isVehicleTypeInRolesWithoutVehicles =
        rolesForDriverWithoutVehicles.includes(+roleData.driver.vehicle_type);

    const extraDriverDetail = () => {
        if (+roleData.driver.vehicle_type === vehicleTypes.MOTORCYCLE) {
            return (
                <div>
                    <p className="question">Does the driver need a box?</p>
                    <form>
                        <div
                            className={
                                roleData.driver.minimum_delivery_box == '4'
                                    ? 'role-item active'
                                    : roleItemClassName
                            }
                        >
                            <label className="item-circle-wrapper">
                                <input
                                    type="radio"
                                    name="minimum_delivery_box"
                                    value="4"
                                    onChange={changeExtraDetails}
                                />
                                <i className="icon icon-pizzabox normal" />
                                <i className="icon icon-pizzabox active" />
                            </label>
                            <p className="role-item-name">
                                Pizza box <br />
                                <br />
                            </p>
                        </div>
                        <div
                            className={
                                roleData.driver.minimum_delivery_box == '2'
                                    ? 'role-item active'
                                    : roleItemClassName
                            }
                        >
                            <label className="item-circle-wrapper">
                                <input
                                    type="radio"
                                    name="minimum_delivery_box"
                                    value="2"
                                    onChange={changeExtraDetails}
                                />
                                <i className="icon icon-smallbox normal" />
                                <i className="icon icon-smallbox active" />
                            </label>
                            <p className="role-item-name">
                                Small box <br />
                                <br />
                            </p>
                        </div>
                        <div
                            className={
                                roleData.driver.minimum_delivery_box == '0'
                                    ? 'role-item active'
                                    : roleItemClassName
                            }
                        >
                            <label className="item-circle-wrapper">
                                <input
                                    type="radio"
                                    name="minimum_delivery_box"
                                    value="0"
                                    onChange={changeExtraDetails}
                                />
                                <i className="icon icon-close normal" />
                                <i className="icon icon-close active" />
                            </label>
                            <p className="role-item-name">
                                We provide <br /> vehicle
                            </p>
                        </div>
                    </form>
                </div>
            );
        }

        if (+roleData.driver.vehicle_type === vehicleTypes.VAN) {
            return (
                <div>
                    <p className="question">Which van size do you need?</p>
                    <form>
                        <div
                            className={
                                roleData.driver.medium_van == 0 &&
                                roleData.driver.large_van == 0
                                    ? 'role-item active'
                                    : roleItemClassName
                            }
                        >
                            <label className="item-circle-wrapper">
                                <input
                                    type="radio"
                                    name="van_size"
                                    value="S"
                                    onChange={changeExtraDetails}
                                />
                                <i className="icon icon-smallvan normal" />
                                <i className="icon icon-smallvan active" />
                            </label>
                            <p className="role-item-name">
                                Small
                                <br />
                            </p>
                        </div>
                        <div
                            className={
                                roleData.driver.medium_van == 1
                                    ? 'role-item active'
                                    : roleItemClassName
                            }
                        >
                            <label className="item-circle-wrapper">
                                <input
                                    type="radio"
                                    name="van_size"
                                    value="M"
                                    onChange={changeExtraDetails}
                                />
                                <i className="icon icon-mediumvan normal" />
                                <i className="icon icon-mediumvan active" />
                            </label>
                            <p className="role-item-name">
                                Medium
                                <br />
                            </p>
                        </div>
                        <div
                            className={
                                roleData.driver.large_van == 1
                                    ? 'role-item active'
                                    : roleItemClassName
                            }
                        >
                            <label className="item-circle-wrapper">
                                <input
                                    type="radio"
                                    name="van_size"
                                    value="L"
                                    onChange={changeExtraDetails}
                                />
                                <i className="icon icon-largevan normal" />
                                <i className="icon icon-largevan active" />
                            </label>
                            <p className="role-item-name">
                                Large / Giant
                                <br />
                            </p>
                        </div>
                        <a
                            href="https://www.comparethemanandvan.co.uk/size-guide"
                            target="_blank"
                            className="role-item notice"
                            rel="noreferrer"
                        >
                            Find out more about van sizes...
                        </a>
                    </form>
                </div>
            );
        }

        return (
            <div>
                <p className="question 15px-font">Do you need vehicles?</p>
                <form className="tight">
                    <div
                        className={
                            +roleData.driver.vehicle_type ===
                                vehicleTypes.CAR &&
                            +roleData.driver.own_vehicle === 1
                                ? 'role-item active'
                                : roleItemClassName
                        }
                    >
                        <label
                            className={
                                !isVehicleTypeInRolesWithoutVehicles
                                    ? 'item-circle-wrapper'
                                    : 'item-circle-wrapper item-circle-wrapper-disabled'
                            }
                        >
                            <input
                                type="radio"
                                name="own_vehicle"
                                value="1"
                                onChange={e =>
                                    !isVehicleTypeInRolesWithoutVehicles
                                        ? changeExtraDetails(e)
                                        : null
                                }
                            />
                            <i
                                className={`icon normal${
                                    +roleData.driver.vehicle_type ===
                                    vehicleTypes.CAR
                                        ? ' icon-user-car'
                                        : ' icon-user-truck'
                                }`}
                            />
                            <i
                                className={`icon active${
                                    +roleData.driver.vehicle_type ===
                                    vehicleTypes.CAR
                                        ? ' icon-user-car'
                                        : ' icon-user-truck'
                                }`}
                            />
                        </label>
                        <p className="role-item-name">
                            {+roleData.driver.vehicle_type === vehicleTypes.CAR
                                ? 'I need drivers and their car'
                                : 'Drivers and their vehicles are needed'}
                        </p>
                    </div>
                    <div
                        className={
                            +roleData.driver.own_vehicle === 0
                                ? 'role-item active'
                                : roleItemClassName
                        }
                    >
                        <label className="item-circle-wrapper">
                            <input
                                type="radio"
                                name="own_vehicle"
                                value="0"
                                onChange={changeExtraDetails}
                            />
                            <i className="icon icon-user normal" />
                            <i className="icon icon-user active" />
                        </label>
                        <p className="role-item-name">
                            I just need <br /> the drivers
                        </p>
                    </div>
                </form>
            </div>
        );
    };

    const extraDriverSkills = () => {
        if (
            +roleData.driver.vehicle_type == vehicleTypes.CLASS_1 ||
            +roleData.driver.vehicle_type == vehicleTypes.CLASS_2
        ) {
            return (
                <div>
                    <p className="question">Any extra skill(s)?</p>
                    <form className="tight">
                        <div
                            className={
                                roleData.driver.adr == 1
                                    ? 'role-item active'
                                    : roleItemClassName
                            }
                        >
                            <label className="item-circle-wrapper">
                                <input
                                    type="checkbox"
                                    name="adr"
                                    value="1"
                                    onChange={changeExtraDetails}
                                />
                                <i className="icon icon-driving-adr normal" />
                                <i className="icon icon-driving-adr active" />
                            </label>
                            <p className="role-item-name">ADR</p>
                        </div>
                        <div
                            className={
                                roleData.driver.hiab == 1
                                    ? 'role-item active'
                                    : roleItemClassName
                            }
                        >
                            <label className="item-circle-wrapper">
                                <input
                                    type="checkbox"
                                    name="hiab"
                                    value="1"
                                    onChange={changeExtraDetails}
                                />
                                <i className="icon icon-driving-hiab normal" />
                                <i className="icon icon-driving-hiab active" />
                            </label>
                            <p className="role-item-name">HIAB</p>
                        </div>
                    </form>
                </div>
            );
        }

        return null;
    };

    const extraSkillsDetailGeneral = () => {
        if (service_key) {
            const currentRoleDataFieldName = servicesStructure[service_key].role_field_name;
            const currentServiceFieldName = servicesStructure[service_key].role_filter_name;
            const currentRole = roleData[service_key][currentRoleDataFieldName as keyof typeof roleData[TServiceKey]];
            const currentServiceStructure = servicesStructure[service_key][currentServiceFieldName][currentRole];

            const skillKeys = Object.keys(currentServiceStructure).filter(
                key => !['label', 'icon_name', 'client_enabled'].includes(key)
            );
            const hasSkills = skillKeys.length > 0;

            return (
                <div>
                    <p className="question">{hasSkills ? 'Any extra skill(s)?' : ''}</p>
                    <form className='tight'>
                        <div className='select-extra-skills-container'>
                            {hasSkills ? skillKeys.map((skillKey: keyof typeof roleData[TServiceKey]) => {
                                const skillDetail = currentServiceStructure[skillKey];
                                const isActive =
                                    +roleData[service_key][skillKey] === 1
                                    || roleData[service_key][skillKey] === true;
                                const iconName = skillDetail[isActive.toString()].icon_name
                                    ? `icon ${skillDetail.true.icon_name}`
                                    : '';
                                return (
                                    <div
                                        key={skillKey}
                                        className={isActive ? 'role-item active' : roleItemClassName}
                                    >
                                        <label className="item-circle-wrapper">
                                            <input
                                                type="checkbox"
                                                checked={isActive}
                                                name={skillKey}
                                                value="1"
                                                onChange={changeExtraDetails}
                                            />
                                            {iconName && (
                                                <>
                                                    <i className={`${iconName} normal`} />
                                                    <i className={`${iconName} active`} />
                                                </>
                                            )}
                                        </label>
                                        <p className="role-item-name">{skillDetail.true.label}</p>
                                    </div>
                                );
                            }) : null}
                        </div>
                    </form>
                </div>
            );
        }
        return null;
    };

    return (
        <div className={classNames('card card-role-detail', className)}>
            <div className="card-content">
                <div className="items-container">
                    <p className="question">What service do you need?</p>
                    <SelectRoleComponent
                        servicesStructure={servicesStructure}
                        serviceKey={service_key}
                        roleData={roleData}
                        // @ts-ignore
                        update={changeExtraDetails}
                        disabled={false}
                        mode={mode}
                        extraDriverDetail={extraDriverDetail}
                        extraDriverSkills={extraDriverSkills}
                        extraSkillsDetailGeneral={extraSkillsDetailGeneral}
                        displayRoleIcon={displayRoleIcon}
                        isAgent={user.isAgent}
                    />
                </div>
            </div>
        </div>
    );
}
